import { AccountDepartment } from './AccountDepartment';
import { Address } from './Address';
import { Amount } from './Amount';
import { AuthorizedOfficer } from './AuthorizedOfficer';
import { AuthorizedOwner } from './AuthorizedOwner';
import { BusinessActivity } from './BusinessActivity';
import { BusinessRegistrationType } from './BusinessRegistrationType';
import { CompanyRegistrationType } from './CompanyRegistrationType';
import { Country } from './Country';
import { DocumentDetails } from './DocumentDetails';
import { EntityType } from './EntityType';
import { PaymentMethodDetails } from './PaymentDetails';

// any business which is my own business, my client, my vendor
export interface Business {
  r2AId?: string;
  name: string;
  country: Country;
  PAN?: string;
  federalEIN?: string;
  CIN?: string;
  GSTIN?: string;
  iecCode?: string;
  noGSTOrIEC?: string;
  llpIN?: string;
  address?: Address;
  billingAddress?: Address;
  businessRegistrationType?: BusinessRegistrationType;
  businessActivity?: BusinessActivity;
  directors?: AuthorizedOwner[];
  websiteUrl?: string;
  onlineShopLink?: string;
  avgInvoiceSizeInInr?: number;
  avgNoOfInvoicesPerMonth?: number;
  dateEstablished?: string;
  authorizedOwnerName?: string;
  authorizedOfficer?: AuthorizedOfficer;
  entityType?: EntityType[];
  emailAddress?: string;
  phoneNumber?: string;
  contactPerson?: string;
  vendorName?: string;
  clientName?: string;
  requestedDate?: string;
  profileImagePath?: string;
  completed?: boolean;
  role?: string;
  createdDate?: string;
  documents?: DocumentDetails[];
  active?: number;
  overdue?: number;
  paid?: number;
  isPartner?: boolean;
  partnerId?: string;
  partnerRelationshipStatus?:
    | 'approved'
    | 'rejected'
    | 'requested'
    | 'verifying';
  partnerRelationshipRejectionReason?: string;
  currentBalance?: Amount;
  bankDetails?: PaymentMethodDetails[];
  nonEditables?: BusinessSearchNonEditablesEnum[];
  doingbusinessAs?: string;
  accountDepartment?: AccountDepartment;
  companyType?: CompanyRegistrationType;
}

export enum BusinessSearchNonEditablesEnum {
  PAN,
  CIN,
  GSTIN,
  name,
  AuthorizedOwnerName,
  llpIN,
}
